/**
@flow
    Generated by Zeplin
    Copyright (C) 2017 - present Zeplin

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

const colors = {
  blueyGreyFour: 'rgb(136,146,164)',
  white10: 'rgba(255, 255, 255, 0.1)',
  white20: 'rgba(255, 255, 255, 0.2)',
  aang: '#004acd',
  almostBlack: '#090f18',
  amon: '#33c6dd',
  angor: '#8892a4',
  appa: '#e6f8fb',
  argh: '#b2b9c4',
  asami: '#e69a00',
  azula: '#bf4240',
  baatar: '#f2eeed',
  babyBlue: '#accdff',
  barbara: '#97a0b0',
  battleshipGrey: '#637381',
  beige: '#f8dede',
  black: '#000000',
  blinky: '#253759',
  blue: '#004acd',
  blueberry: '#65469b',
  blueGrey: '#5c6a83',
  blueyGrey: '#959dad',
  blueyGreyTwo: '#919eab',
  blueyGreyThree: '#8ca0b3',
  brightBlue: '#0064ff',
  bular: '#6a778e',
  bumi: '#62bd88',
  cerulean: '#007ace',
  chan: '#cbbce7',
  clearBlue: '#2d7fff',
  coolGrey: '#b2b9c4',
  coolGreyTwo: '#94989e',
  coral: '#ef5350',
  dark: '#212b36',
  darkBlueGrey: '#101c3a',
  darkGreyBlue: '#313e5a',
  darkGreyBlueTwo: '#253858',
  darkishGreen: '#2d8d4d',
  darkSeaFoam: '#2f8a55',
  darkSeafoamGreen: '#3bad6a',
  darkTaupe: '#795548',
  deepLavender: '#714eaf',
  deepLilac: '#9879ce',
  dodgerBlue: '#4e94ff',
  draal: '#5b6982',
  duckEgg: '#ccf1f6',
  dusk: '#40506d',
  dusk60: 'rgba(64, 80, 109, 0.6)',
  dusk80: 'rgba(64, 80, 109, 0.8)',
  duskFour: '#455471',
  duskThree: '#4a5975',
  dusk500: '#366564',
  duskTwo: '#3e4b66',
  dustyOrange: '#ed6347',
  fadedRed: '#cb3538',
  gansu: '#ebf7f0',
  gilak: '#99e3ee',
  greenyBlue: '#47c1bf',
  hiroshi: '#ffdd99',
  iceBlue: '#f3f8ff',
  iris: '#7e57c2',
  irisTwo: '#5c6ac4',
  iroh: '#d74b48',
  izumi: '#f27573',
  jet: '#af9991',
  jin: '#94776d',
  katara: '#00b8d4',
  kenji: '#f2eef9',
  korra: '#0093aa',
  kuvira: '#3bad6a',
  kyoshi: '#61443a',
  lavender: '#e9def8',
  lightBlueGrey: '#e3edf7',
  lightSkyBlue: '#d2e4ff',
  lightTeal: '#b6eceb',
  lipstick: '#e83b3f',
  mai: '#f9bab9',
  mako: '#ffcd66',
  mango: '#ffbc33',
  manilla: '#ffea8a',
  midnightBlue: '#071c42',
  ming: '#b1dec3',
  nana: '#dfe1e6',
  nearWhite: '#fafafb',
  nightSky: '#13274b',
  ochre: '#cc8900',
  opal: '#e4ddda',
  orangeYellow: '#ffab00',
  otto: '#f5f6f7',
  ozai: '#fdeeee',
  paleGrey: '#ebedf0',
  paleGreyFive: '#f3f4fa',
  paleGreyFour: '#e6e8ec',
  paleGreyThree: '#f9fafb',
  paleGreyTwo: '#dfe3e8',
  paleRed: '#e2574c',
  pastelBlue: '#9dc0ff',
  pema: '#ffeecc',
  pepperJack: '#a6adbb',
  pong: '#89cea6',
  pumpkin: '#de8907',
  rainySky: '#0a3981',
  royal: '#0d3290',
  scarlet: '#bf0711',
  seaweed: '#359c5f',
  sela: '#d8efe1',
  shadowColor: 'rgba(151,160,176,0.44)',
  shadowColorLight: 'rgba(151,160,176,0.24)',
  shadowColor12: 'rgba(151,160,176,0.12)',
  shannon: '#ebedf0',
  silver: '#c1c6d0',
  silverThree: '#c1c7d0',
  silverTwo: '#c4cdd5',
  slate: '#57637b',
  slateGrey: '#626a79',
  slateGreyTwo: '#656c74',
  slateTwo: '#49556f',
  slateThree: '#586680',
  slateFour: '#576d7e',
  sokka: '#66d4e5',
  steel: '#798499',
  steelTwo: '#757f93',
  strickler: '#4f5e79',
  suki: '#b29ada',
  suyin: '#6d4d41',
  than: '#c9bbb6',
  toby: '#344564',
  toph: '#795548',
  toza: '#fff7e6',
  trueBlue: '#0231c2',
  turquoiseBlue: '#00b8d4',
  twilightBlue: '#0d47a1',
  twilightBlueThree: '#0b286e',
  twilightBlueTwo: '#0a3981',
  tyLee: '#fcdddc',
  unalaq: '#00a6bf',
  ursa: '#f59896',
  vandel: '#ffab00',
  veryLightBlue: '#f3f8ff',
  veryLightBlue80: 'rgba(240, 248, 255, 0.8)',
  transparent: '#00000000',
  veryLightPink: '#fbeae5',
  washedOutGreen: '#d4f6c2',
  white: '#ffffff',
  whiteFour: '#d8d8d8',
  whiteThree: '#f9f9f9',
  whiteTwo: '#f2f2f2',
  yagoda: '#e5ddf3',
  zuko: '#ef5350'
}
export default colors
